@for (column of columns; track column) {
  @switch (column.type) {
    @case (EnumColumnType.INPUT) {
      <ng-container *ngTemplateOutlet="InputCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.INPUT_INLINE_EDIT) {
      <ng-container *ngTemplateOutlet="InputInlineEditCol; context: { params: { col: column } }"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="SimpleCol; context: { params: { col: column } }"></ng-container>
    }
  }
}

<ng-template #SimpleCol let-data="params">
  <app-column-control-simple
    class="table-col"
    [row]="row"
    [column]="data.col"
    [style]="data.col.cssStyle"
  ></app-column-control-simple>
</ng-template>

<ng-template #InputCol let-data="params">
  @if (data.col.input; as input) {
    <div class="form-check table-col" [style]="input.cssStyle">
      @if (input.bindInput) {
        @if (input.type == 'text') {
          <input
            min="0"
            (keydown.enter)="$event.preventDefault()"
            type="number"
            [value]="row.quantity"
            (focusout)="onChange($event)"
            class="form-control ng-untouched ng-pristine ng-valid col-control-textInput"
            placeholder="0"
            required
            />
        }
      } @else {
        @if (input.type == 'text') {
          <input
            min="0"
            (keydown.enter)="$event.preventDefault()"
            (keyup)="onChange($event)"
            class="form-control ng-untouched ng-pristine ng-valid col-control-textInput"
            placeholder="0"
            required
            />
        }
      }
    </div>
  }
</ng-template>

<ng-template #InputInlineEditCol let-data="params">
  <app-column-control-input-inline
    class="table-col"
    [row]="row"
    [column]="data.col"
    (eventValue)="onChange($event)"
  ></app-column-control-input-inline>
</ng-template>
